<template>
  <div>
    <title-edit header="Main Branch" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="4"  class="label">
        <label>Branch Name TH* :</label>
      </v-col>
      <v-col cols="12" sm="6" >
        <input-text-field @update="updateBranchNameTH" :model="form.branch_name_th" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4"  class="label">
        <label>Branch Name EN* :</label>
      </v-col>
      <v-col cols="12" sm="6"   xs="12">
        <input-text-field @update="updateBranchNameEN" :model="form.branch_name_en" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4"   class="label">
        <label>Tag name * :</label>
      </v-col>
      <v-col cols="12" sm="6"   xs="12">
        <input-text-field @update="updateTagName" :model="form.tag_name" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4"   class="label">
        <label>Cover image desktop name:</label>
      </v-col>
      <v-col cols="12" sm="6"  >
        <input-text-field
          @update="updateImgCoverDesktopName"
          :model="form.img_cover_desktop_name"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4"   class="label">
        <label>Cover image desktop* :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="6"  >
        <input-image-upload
          id="input1"
          height="200px"
          :name="form.img_cover_desktop_name"
          @update="updateImgCoverDesktopPath"
          menu="branch"
          :model="form.desktop_path_show"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4"   class="label">
        <label>Cover image mobile name : </label>
      </v-col>
      <v-col cols="12" sm="6"   xs="12">
        <input-text-field @update="updateImgCoverMobileName" :model="form.img_cover_mobile_name" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4"   class="label">
        <label>Cover image mobile* :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="6"  >
        <input-image-upload
          id="input2"
          height="140px"
          width="140px"
          col="col-6"
          @update="updateImgCoverMobilePath"
          menu="branch"
          :name="form.img_cover_mobile_name"
          :model="form.mobile_path_show"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4"   class="label">
        <label>Serivce area image :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
        </div>
      </v-col>
      <v-col cols="12" sm="6"  >
        <input-image-upload
          id="image3"
          height="150px"
          width="350px"
          col="col-6"
          @update="updateServiceAreaImage"
          menu="branch"
          :model="form.service_area_image_show"
        />
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteBranch" />
<!--      <preview-button />-->
      <save-button @click.native="saveBranch" />
    </div>
  </div>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import LineHr from "../../../components/Icon/line-hr";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import SwitchSelect from "../../../components/Input/StyleUtility";
import { mapState } from "vuex";
export default {
  name: "MainBranchEdit",
  components: {
    SwitchSelect,
    InputImageUpload,
    LineHr,
    SaveButton,
    PreviewButton,
    DeleteButton,
    TitleEdit,
    InputTextField
  },
  computed: {
    ...mapState({
      form: state => {
        return state.Branch.form;
      }
    })
  },
  data() {
    return {};
  },
  methods: {
    validateSave() {
      if (!this.form.branch_name_th) {
        alert("please insert Branch Name TH !");
        return false;
      } else if (!this.form.branch_name_en) {
        alert("please insert Branch Name EN !");
        return false;
      } else if (!this.form.img_cover_desktop_path) {
        alert("please select Cover image desktop !");
        return false;
      } else if (!this.form.img_cover_mobile_path) {
        alert("please select Cover image mobile !");
        return false;
      } else {
        return true;
      }
    },
    saveBranch() {
      if (this.validateSave()) {
        this.$store
          .dispatch("Branch/saveBranch", {
            id: this.form.branch_id,
            data: this.form
          })
          .then(res => {
            alert(res.response_msg);
            if (res.response_code == 200) {
              this.goToBranchTable();
            }
          })
          .catch(() => {
            alert("save data fail!");
          });
      }
    },
    goToBranchTable() {
      this.$router.push("/branch/main-branch");
    },
    deleteBranch() {
      this.$store
        .dispatch("Branch/deleteBranch", this.form.branch_id)
        .then(res => {
          alert(res.response_msg);
          if (res.response_code === 200) {
            this.goToBranchTable();
          }
        })
        .catch(() => {
          alert("delete branch fail!");
        });
    },
    updateBranchNameTH(val) {
      this.form.branch_name_th = val;
    },
    updateBranchNameEN(val) {
      this.form.branch_name_en = val;
    },
    updateTagName(val) {
      this.form.tag_name = val;
    },
    updateImgCoverDesktopPath(item) {
      this.form.img_cover_desktop_path = item.imagePath;
      this.form.desktop_path_show = item.fullImagePath;
    },
    updateImgCoverDesktopName(val) {
      this.form.img_cover_desktop_name = val;
    },
    updateImgCoverMobilePath(item) {
      this.form.img_cover_mobile_path = item.imagePath;
      this.form.mobile_path_show = item.fullImagePath;
    },
    updateImgCoverMobileName(val) {
      this.form.img_cover_mobile_name = val;
    },
    updateServiceAreaImage(val) {
      this.form.service_area_image = val.imagePath;
      this.form.service_area_image_show = val.fullImagePath;
    }
  }
};
</script>

<style lang="scss" scoped></style>
